/* Whether the signed-in member is an admin, for showing admin-only controls
   deep in the tree (e.g. removing someone else's post). The server checks it
   again on every admin action; this only decides what to show. */
let admin = false;
export const setAdminFlag = (on) => { admin = Boolean(on); };
export const isAdminNow = () => admin;
